import react from "react";
import Request from "../../../api/Requests";

const getListCampaigns = (params) => {
    return Request('campaigns/list', 'POST', params, true);
}
const postFormCampaigns = (params) => {
    return Request('campaigns/form-save', 'POST', params, true);
}

const getVenuesEventsPromote = (params) => {
    return Request('campaigns/get-venues-events-promote', 'GET', params, true);
}

const getCampaignInfo = (params) => {
    return Request('campaigns/get-campaign-info', 'GET', params, true);
}


const getNotiicationsLimits = (params) => {
    return Request('campaigns/get-campaign-notification-limits', 'POST', params, true);
}


export default {
    getListCampaigns,
    postFormCampaigns,
    getVenuesEventsPromote,
    getCampaignInfo,
    getNotiicationsLimits
}